

export const ReadingFlagTypes = [
    { name: "Reset", value: "reset" },
    { name: "Swap", value: "swap" },
    { name: "Bad", value: "bad" },
    { name: "Updated", value: "updated" },
];

export const ReadingAggregationFrequencies = [
    { name: "Minutely", value: "MINUTELY" },
    { name: "Hourly", value: "HOURLY" },
    { name: "Daily", value: "DAILY" },
    { name: "Weekly", value: "WEEKLY" },
    { name: "Monthly", value: "MONTHLY" },
    { name: "Yearly", value: "YEARLY" },
];

export const ReadingAggregationFunctions = [
    { name: "Last", value: "LAST" },
    { name: "First", value: "FIRST" },
    { name: "Min", value: "MIN" },
    { name: "Max", value: "MAX" },
    { name: "Avg", value: "AVG" },
    { name: "Median", value: "MEDIAN" },
    { name: "Sum", value: "SUM" },
    { name: "Diff", value: "DIFF" },
    { name: "Consumption", value: "CONSUMPTION" },
];
